module.exports = __webpack_public_path__ + "img/work.c85e652d.svg";